<template>
  <div class="big">
    <div class="page_title">月度药品销售数据核对</div>
    <div style="padding: 20px">
      <div class="container">
        <div class="between">
          <div class="searchbox">
            <div class="item">
              <span class="itemtitle">月份</span>
              <el-date-picker
                v-model="month"
                type="month"
                placeholder="选择月"
                :picker-options="pickerOptions"
                style="width: 160px; margin-left: 10px"
                format="yyyy年MM月"
                value-format="yyyy-MM"
                :clearable="false"
                @change="search"
              >
              </el-date-picker>
            </div>
            <div class="item">
              <span>药房名称</span>
              <!-- <el-input
                v-model="hospital_name"
                style="width: 160px; margin-left: 10px"
                @change="search"
                clearable
              ></el-input> -->
              <myInputSerch v-model="hospital_name" @update="search" style="margin:0 10px 0 10px;"></myInputSerch>
            </div>
            <div class="item">
              <span>文件名称</span>
              <el-input
                v-model="file_name"
                style="width: 160px; margin:0 10px"
                @change="search"
                clearable
              ></el-input>
              <el-button
                plain
                style="background: #ececec"
                size="medium"
                @click="search"
              >查询</el-button>
            </div>
          </div>
          <el-button
            type="primary"
            @click="uploadDia"
            :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('784')
                      : false
                  "
          >上传文件</el-button>
        </div>
        <div style="text-align: left;margin-bottom:16px">
          <span style="margin-right:10px">是否确认</span>
          <el-radio-group
            v-model="status"
            @change="search"
          >
            <el-radio :label="0">全部</el-radio>
            <el-radio :label="1">未确认</el-radio>
            <el-radio :label="2">已确认</el-radio>
          </el-radio-group>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            @sort-change="changeOrder"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              prop="hospital_name"
              label="药房名称"
              sortable="custom"
            >
            </el-table-column>
            <el-table-column
              prop="org_name"
              label="机构名称"
            >
              <template slot-scope="scope">
                <div>{{scope.row.org_name}}</div>
                <div>{{scope.row.org_code}}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="file_name"
              label="文件名称"
            ></el-table-column>
            <el-table-column
              prop="file_time"
              label="上传文件时间"
            ></el-table-column>
            <el-table-column
              prop="market_price"
              label="月度抵扣货款总额"
            ></el-table-column>
            <el-table-column
              prop="sure_name"
              label="药房负责人确认"
            ></el-table-column>
            <el-table-column
              prop="sure_time"
              label="确认时间"
            ></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="uploadAgain(scope.row)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('784')
                      : false
                  "
                  v-if="!scope.row.sure_time"
                >重新上传</el-button>
                <el-button
                  type="text"
                  @click="download(scope.row.file_url_str)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('784')
                      : false
                  "
                >下载</el-button>
                <el-button
                  type="text"
                  @click="delFile(scope.row.market_log_id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('785')
                      : false
                  "
                  v-if="!scope.row.sure_time"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 上传弹窗 -->
    <el-dialog
      title="待核对数据文件上传"
      :visible.sync="uploaddia"
      width="420px"
      style="text-align: left"
      :close-on-click-modal="false"
    >
      <div style="padding:20px">
        <div style="margin-bottom:15px;font-weight:600">
          <span style="margin-right:20px">当前选择时间</span>
          <span>{{upload_month}}</span>
        </div>
        <div>选择药房</div>
        <div>
          <el-select
            style="width:300px;margin:10px 0 20px"
            @change="changeHospital"
            v-model="uploadData.hospital_id"
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
            clearable=""
          >
            <el-option
              v-for="item in hospitalList"
              :key="item.value"
              :label="item.hospital_name"
              :value="item.hospital_id"
            >
            </el-option>
          </el-select>
          <!-- <el-select
            v-model="uploadData.hospital_id"
            placeholder="请选择"
            style="width:300px;margin:10px 0 20px"
            @change="changeHospital"
          >
            <el-option
              v-for="item in hospitalList"
              :key="item.value"
              :label="item.hospital_name"
              :value="item.hospital_id"
            >
            </el-option>
          </el-select> -->
        </div>
        <div
          style="margin-bottom:20px"
          v-if="org_name"
        >
          机构名：{{org_name}}
        </div>
        <div>导入文件</div>
        <div
          class="between"
          style="margin:10px 0 20px"
        >
          <el-input
            v-model="uploadData.file_name"
            style="width:300px;"
          >
          </el-input>
          <el-upload
            class="avatar-uploader"
            :action="uploadUrl"
            :data="uploadExtraData"
            :headers="uploadHeaders"
            :show-file-list="false"
            name="image"
            ref="upload"
            :limit="1"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <el-button>导入</el-button>
          </el-upload>
        </div>
        <div>月度抵扣货款总额</div>
        <div style="margin:10px 0 20px">
          <el-input-number
            v-model="uploadData.market_price"
            :min="0"
            label="请输入"
            :controls="false"
            style="width:300px;margin-right:10px"
          ></el-input-number>
          <span>元</span>
        </div>
        <div style="text-align: center">
          <el-button
            plain
            size="medium"
            @click="uploaddia=false"
          >取消</el-button>
          <el-button
            type="primary"
            size="medium"
            @click="confirmUpload"
          >确认上传</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import myInputSerch from '@/components/myInputSerch';
import constant from '../../../service/common/constant';
import _ from 'lodash';
import dayjs from 'dayjs';
export default {
  components: {
    myInputSerch
  },
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      month: '',
      hospital_name: '',
      file_name: '',
      status: 0,
      orderby: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      uploaddia: false,
      upload_month: '',
      hospitalList: [],
      uploadData: {
        hospital_id: '',
        file_name: '',
        file_url: '',
        market_price: undefined
      },
      uploadExtraData: {
        img_type: 6,
        suffix: '.jpg'
      },
      org_name: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    uploadUrl() {
      if (process.env.NODE_ENV == 'development') {
        // 本地开发使用 api 前缀
        return 'api/platform/upload/uploadFile';
      } else {
        return 'platform/upload/uploadFile';
      }
    },
    uploadHeaders: function () {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ['version', 'platform']),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken
        }
      );
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        month: this.month ? dayjs(this.month).format('YYYY-MM') : '',
        hospital_name: this.hospital_name,
        file_name: this.file_name,
        status: this.status,
        order: this.orderby
      };
      this.axios
        .post('platform/hospital/getMonthMarketLists', data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            this.tableData = res.data.list.map((item) => {
              item.file_time = dayjs
                .unix(item.file_time)
                .format('YYYY-MM-DD HH:mm');
              item.sure_time = item.sure_time
                ? dayjs.unix(item.sure_time).format('YYYY-MM-DD HH:mm')
                : '';
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },
    //更改顺序
    changeOrder(value) {
      let order = value.order;
      let prop = value.prop;
      //升序
      if (order == 'ascending') {
        if (prop == 'hospital_name') {
          this.orderby = 1;
        }
      }
      //降序
      if (order == 'descending') {
        if (prop == 'hospital_name') {
          this.orderby = 2;
        }
      }
      if (!order) {
        this.orderby = 0;
      }
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    handleSelectionChangetable(val) {
      this.Selection = val;
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //上传弹窗
    uploadDia() {
      this.uploadData = {
        hospital_id: '',
        file_name: '',
        file_url: '',
        market_price: undefined
      };
      this.upload_month = dayjs(this.month).format('YYYY年MM月');
      this.uploaddia = true;
    },
    //重新上传
    uploadAgain(row) {
      this.uploadData = {
        hospital_id: row.hospital_id,
        file_name: row.file_name,
        file_url: row.file_url,
        market_log_id: row.market_log_id,
        market_price: row.market_price
      };
      this.upload_month = dayjs(this.month).format('YYYY年MM月');
      this.uploaddia = true;
    },
    //上传成功
    handleAvatarSuccess(res) {
      if (res.code === 0) {
        //半路径
        this.uploadData.file_url = res.data.pic;
        this.$refs.upload.clearFiles();
      } else {
        this.$message.error(res.message);
      }
    },
    //上传之前
    beforeAvatarUpload(file) {
      const isText = file.type === 'application/vnd.ms-excel';
      const isTextComputer =
        file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const isEmpty = file.size > 0;
      if (!isText && !isTextComputer) {
        this.$message.error('上传文件只能是CSV或Excel文件');
        return false;
      }
      if (!isEmpty) {
        this.$message.error('请不要上传空文件');
        return false;
      }
      this.uploadData.file_name = file.name;
      const suffix = file.name.substring(file.name.lastIndexOf('.'));
      this.uploadExtraData.suffix = suffix;
      this.uploadExtraData.img_type = 6;
      this.uploadHeaders.timestamp = Date.now();
      return (isText && isEmpty) || (isTextComputer && isEmpty);
    },
    //获取药房列表
    getHospitalList() {
      let data = {
        org_type: 0,
        hospiatl_type: 0,
        page: 1,
        pageNumber: 10000
      };
      this.axios.post('platform/hospital/getHospitaList', data).then((res) => {
        this.hospitalList = res.data.list.map((item) => {
          return {
            hospital_id: item.hospital_id,
            org_name: item.org_name,
            hospital_name:
              item.hospital_name +
              (item.org_name ? '【' + item.org_name + '】' : '')
          };
        });
      });
    },
    //搜索药房
    remoteMethod(query) {
      this.getHospitalList();
      if (query !== '') {
        setTimeout(() => {
          let arr = [];
          arr = this.hospitalList.filter((item) => {
            return (
              item.hospital_name.toLowerCase().indexOf(query.toLowerCase()) >
                -1 ||
              (item.org_name
                ? item.org_name.toLowerCase().indexOf(query.toLowerCase()) > -1
                : false)
            );
          });
          this.hospitalList = arr;
        }, 500);
      } else {
        this.getHospitalList();
      }
    },
    changeHospital(value) {
      if (!value) {
        this.getHospitalList();
        return false;
      }
      let data = this.hospitalList.find((ele) => {
        if (ele.hospital_id == value) {
          return ele;
        }
      });
      if (data.org_name) {
        this.org_name = data.org_name;
      } else {
        this.org_name = '';
      }
    },
    //确认上传文件
    confirmUpload() {
      if (
        !this.uploadData.hospital_id ||
        !this.uploadData.file_name ||
        !this.uploadData.file_url ||
        !this.uploadData.market_price
      ) {
        this.$message.error('请完善上传数据后再确认上传');
        return false;
      }
      let data = this.uploadData;
      data.month = this.month;
      this.axios.post('platform/hospital/saveMonthMarket', data).then((res) => {
        if (res.code == 0) {
          this.$message.success('上传成功');
          this.uploaddia = false;
          this.getList();
        }
      });
    },
    //下载文件
    download(file_url_str) {
      window.open(file_url_str);
    },
    delFile(market_log_id) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/hospital/deleteMonthMarket', { market_log_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('删除成功');
                this.getList();
              }
            });
        })
        .catch(() => {});
    }
  },
  created() {
    let Year = new Date().getFullYear();
    let month = new Date().getMonth();
    let date = Year + '-0' + month;
    this.month = date;
    this.getList();
    this.getHospitalList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  border-radius: 5px;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  .item {
    margin-right: 20px;
    display: flex;
    align-items: center;
  }
}
.other {
  .el-checkbox {
    width: 130px;
    margin-bottom: 10px;
  }
}
.dialogbox {
  padding: 20px;
  text-align: left;
  .userinfo {
    background: #f2f1f0;
    padding: 10px;
    margin: 12px 0;
    .title {
      display: inline-block;
      width: 70px;
      text-align: right;
      margin-right: 10px;
    }
  }
}
</style>


